/**
 * Query key factory, `[entity, ...params]` convention — same shape as maestro-ui's
 * `['now-playing', streamId]` / `['up-next', streamId]` style, just namespaced under
 * `touchscreen` since this cache is shared with nothing else. Every key is scoped by `venueRef`
 * so a phone switching venues never serves another venue's cached page.
 */
export const touchscreenKeys = {
  all: (venueRef: string) => ["touchscreen", venueRef] as const,
  // Not scoped under `all(venueRef)` — this runs before a venue is known, on the entry screen.
  venueSearch: (query: string) => ["touchscreen", "venue-search", query] as const,
  state: (venueRef: string) => [...touchscreenKeys.all(venueRef), "state"] as const,
  browseGroups: (venueRef: string) => [...touchscreenKeys.all(venueRef), "browse-groups"] as const,
  browseGroupTracks: (venueRef: string, groupId: number) =>
    [...touchscreenKeys.all(venueRef), "browse-group-tracks", groupId] as const,
  search: (venueRef: string, query: string) => [...touchscreenKeys.all(venueRef), "search", query] as const,
  requestsMine: (venueRef: string) => [...touchscreenKeys.all(venueRef), "requests-mine"] as const,
};
